import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { UploadService } from '../upload.service';
import { environment } from '../../../environments/environment';



@Injectable()
export class FileUploadService {

    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService, private uploadService: UploadService) { }

    uploadFile(file): Promise<any> {
        return this.uploadService.makeFileRequest(environment.apiUrl + 'site-api/upload', [file])
            .toPromise()
            .then(
                function(response) {
                    return response[0];
                }
            )
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/file-upload/file-upload.service.ts